import React from 'react'
import SettingApiForm from '../components/setting/settingDomainForm'

const SettingIndex = () => {
    return (
        <>
            <SettingApiForm />
        </>
    )
}

export default SettingIndex